// extracted by mini-css-extract-plugin
export var container = "how-it-works-hero-module--container--f4f40";
export var image = "how-it-works-hero-module--image--65f0a";
export var mobileImage = "how-it-works-hero-module--mobileImage--14561";
export var section = "how-it-works-hero-module--section--95f89";
export var videoButton = "how-it-works-hero-module--videoButton--59bc2";